import React, { useEffect, useMemo, useState } from "react";
import { getSheetsSummaryThiKhaoSat } from "./happyschoolApi";
import ThiKhaoSatSheetModal from "./ThiKhaoSatSheetModal";

// Tab "Báo cáo chấm thi": tổng hợp kết quả chấm 1 môn của kỳ thi khảo sát —
// số bài đã chấm / chưa có điểm, phân bố điểm, thống kê theo phòng, danh sách phiếu
// máy đã tự sửa (SBD/mã đề tô sai), phiếu cần xem lại, thí sinh chưa có điểm.
// Dữ liệu: exam.scores / exam.scoreNotes / exam.answerKeys / exam.deFiles + tóm tắt bài làm (sheets-summary).
// Bấm đúp 1 dòng thí sinh -> mở hồ sơ chấm phiếu (đề, bài làm, đáp án).

const round2 = (x) => Math.round(x * 100) / 100;
const fmt = (n) => (n == null || n === "" ? "" : String(n).replace(".", ","));
const isFix = (t) => /→/.test(t || "");
const BUCKETS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

export default function TabBaoCao({ data, exam, schoolId, examId, roomList, sbdOf, studentByKey, subjByKey, groupOf, classById, isAdmin }) {
  const subjects = data.subjects || [];
  const firstWithScores = subjects.find((s) => Object.keys((exam.scores || {})[s.key] || {}).length)?.key || "toan";
  const [sk, setSk] = useState(firstWithScores);
  const [sum, setSum] = useState({});
  const [err, setErr] = useState("");
  const [open, setOpen] = useState(null);
  const [show, setShow] = useState({ fix: true, review: true, missing: true });
  useEffect(() => {
    setSum({}); setErr("");
    getSheetsSummaryThiKhaoSat(schoolId, examId, sk).then((d) => setSum(d || {})).catch((e) => setErr(e.message));
  }, [schoolId, examId, sk]);

  const scores = (exam.scores || {})[sk] || {};
  const notes = (exam.scoreNotes || {})[sk] || {};
  const ak = (exam.answerKeys || {})[sk];
  const deCount = Object.keys((exam.deFiles || {})[sk] || {}).length;

  const rep = useMemo(() => {
    const takes = (key) => {
      const st = studentByKey[key]; const c = st && classById[st.classId];
      const g = c ? groupOf(c) : null;
      return !!g && ((data.groups[g] || {}).subjects || []).includes(sk);
    };
    const rows = []; const byRoom = [];
    roomList.forEach(([rid, r]) => {
      const list = (r.students || []).filter(takes).map((key) => {
        const st = studentByKey[key] || {}; const sc = scores[key]; const note = notes[key] || ""; const sh = sum[key] || null;
        const row = { key, roomId: rid, room: r.name, location: r.location || "", sbd: (sbdOf[key] || {}).sbd || "", name: st.name || "?", className: st.className || "",
          classId: st.classId, student: { id: key.split("|")[1], name: st.name || "?" }, score: typeof sc === "number" ? sc : null, note, sheet: sh };
        rows.push(row); return row;
      });
      const sc = list.filter((x) => x.score != null).map((x) => x.score);
      byRoom.push({ rid, name: r.name, location: r.location || "", total: list.length, graded: sc.length, missing: list.length - sc.length,
        avg: sc.length ? round2(sc.reduce((a, b) => a + b, 0) / sc.length) : null, max: sc.length ? Math.max(...sc) : null, min: sc.length ? Math.min(...sc) : null,
        fix: list.filter((x) => isFix(x.note)).length, review: list.filter((x) => x.note && !isFix(x.note)).length,
        files: [...new Set(list.map((x) => x.sheet && x.sheet.sourceFile).filter(Boolean))].join(", ") });
    });
    const sc = rows.filter((x) => x.score != null).map((x) => x.score);
    const hist = BUCKETS.map((b) => sc.filter((v) => (b === 9 ? v >= 9 : v >= b && v < b + 1)).length);
    return {
      rows, byRoom, hist, n: rows.length, graded: sc.length, sheets: rows.filter((x) => x.sheet).length, images: rows.filter((x) => x.sheet && x.sheet.hasImage).length,
      avg: sc.length ? round2(sc.reduce((a, b) => a + b, 0) / sc.length) : null, max: sc.length ? Math.max(...sc) : null, min: sc.length ? Math.min(...sc) : null,
      over5: sc.filter((v) => v >= 5).length,
      fix: rows.filter((x) => isFix(x.note)), review: rows.filter((x) => x.note && !isFix(x.note)), missing: rows.filter((x) => x.score == null),
    };
  }, [data, roomList, studentByKey, classById, groupOf, sbdOf, scores, notes, sum, sk]);

  const card = { border: "1px solid #e5e7eb", background: "#fff", borderRadius: 10, padding: "10px 14px", minWidth: 150 };
  const big = { fontSize: 22, fontWeight: 700, color: "#0f766e" };
  const th = { border: "1px solid #e5e7eb", padding: "6px 8px", background: "#f3f4f6", whiteSpace: "nowrap", fontSize: 13 };
  const td = { border: "1px solid #e5e7eb", padding: "4px 8px", fontSize: 13, textAlign: "center" };
  const tdL = { ...td, textAlign: "left" };
  const maxH = Math.max(1, ...rep.hist);
  const Stat = ({ label, value, sub, color }) => <div style={card}><div style={{ fontSize: 12, color: "#6b7280" }}>{label}</div><div style={{ ...big, color: color || big.color }}>{value}</div>{sub && <div style={{ fontSize: 12, color: "#6b7280" }}>{sub}</div>}</div>;
  const List = ({ title, k, rows, color, noteCol = true }) => (
    <div style={{ marginTop: 16 }}>
      <div style={{ fontWeight: 700, cursor: "pointer", color }} onClick={() => setShow((s) => ({ ...s, [k]: !s[k] }))}>{show[k] ? "▾" : "▸"} {title} ({rows.length})</div>
      {show[k] && rows.length > 0 && (
        <div style={{ overflowX: "auto", marginTop: 6 }}>
          <table style={{ borderCollapse: "collapse", width: "100%", background: "#fff" }}>
            <thead><tr><th style={th}>SBD</th><th style={th}>Họ và tên</th><th style={th}>Lớp</th><th style={th}>Phòng</th>{noteCol && <><th style={th}>Mã đề</th><th style={th}>Điểm</th><th style={th}>File / trang</th><th style={th}>Ghi chú</th></>}</tr></thead>
            <tbody>{rows.map((x) => (
              <tr key={x.key} onDoubleClick={() => x.classId && setOpen(x)} style={{ cursor: "pointer" }} title="Bấm đúp để xem đề, bài làm, đáp án">
                <td style={td}>{x.sbd}</td><td style={tdL}>{x.name}</td><td style={td}>{x.className}</td><td style={td}>{x.room}</td>
                {noteCol && <><td style={td}>{x.sheet?.maDe || ""}</td><td style={{ ...td, fontWeight: 600 }}>{fmt(x.score)}</td><td style={td}>{x.sheet ? `${x.sheet.sourceFile} tr.${x.sheet.page}` : ""}</td><td style={{ ...tdL, color: "#b45309" }}>{x.note}</td></>}
              </tr>))}</tbody>
          </table>
        </div>
      )}
    </div>
  );

  return (
    <div>
      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 12 }}>
        <b>Môn:</b>
        <select value={sk} onChange={(e) => setSk(e.target.value)} style={{ padding: "6px 8px", border: "1px solid #d1d5db", borderRadius: 6 }}>
          {subjects.map((s) => <option key={s.key} value={s.key}>{s.label} ({Object.keys((exam.scores || {})[s.key] || {}).length} điểm)</option>)}
        </select>
        {err && <span style={{ color: "#b91c1c", fontSize: 13 }}>{err}</span>}
      </div>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <Stat label="Thí sinh dự thi môn" value={rep.n} />
        <Stat label="Đã có điểm" value={rep.graded} sub={rep.n ? `${Math.round((rep.graded / rep.n) * 100)}%` : ""} />
        <Stat label="Chưa có điểm" value={rep.n - rep.graded} color="#b91c1c" />
        <Stat label="Chấm máy (có bài làm)" value={rep.sheets} sub={`${rep.images} có ảnh phiếu`} />
        <Stat label="Máy đã tự sửa SBD/mã đề" value={rep.fix.length} color="#7c3aed" />
        <Stat label="Phiếu cần xem lại" value={rep.review.length} color="#b45309" />
        <Stat label="Điểm TB · cao · thấp" value={fmt(rep.avg) || "—"} sub={rep.max != null ? `cao ${fmt(rep.max)} · thấp ${fmt(rep.min)}` : ""} />
        <Stat label="Từ 5 điểm trở lên" value={rep.over5} sub={rep.graded ? `${Math.round((rep.over5 / rep.graded) * 100)}% số bài` : ""} />
      </div>
      <div style={{ fontSize: 13, color: "#4b5563", marginTop: 8 }}>
        Đáp án: {ak ? <b>{ak.fileName || "đã lưu"} — {Object.keys(ak.keys || {}).length} mã đề</b> : <span style={{ color: "#b91c1c" }}>chưa lưu</span>} · Đề thi PDF đã tải: <b>{deCount}</b> mã đề
      </div>

      <div style={{ marginTop: 16, fontWeight: 700 }}>Phân bố điểm</div>
      <div style={{ display: "flex", alignItems: "flex-end", gap: 6, height: 150, marginTop: 6, maxWidth: 640 }}>
        {rep.hist.map((v, i) => (
          <div key={i} style={{ flex: 1, textAlign: "center" }}>
            <div style={{ fontSize: 12 }}>{v}</div>
            <div style={{ height: `${(v / maxH) * 110}px`, background: i >= 5 ? "#16a34a" : "#f59e0b", borderRadius: "4px 4px 0 0" }} />
            <div style={{ fontSize: 11, color: "#6b7280" }}>{i === 9 ? "9–10" : `${i}–${i + 1}`}</div>
          </div>
        ))}
      </div>

      <div style={{ marginTop: 16, fontWeight: 700 }}>Theo phòng thi</div>
      <div style={{ overflowX: "auto", marginTop: 6 }}>
        <table style={{ borderCollapse: "collapse", width: "100%", background: "#fff" }}>
          <thead><tr>{["Phòng", "Địa điểm", "Sĩ số", "Có điểm", "Chưa có điểm", "TB", "Cao", "Thấp", "Máy đã sửa", "Cần xem lại", "File scan"].map((h) => <th key={h} style={th}>{h}</th>)}</tr></thead>
          <tbody>{rep.byRoom.map((r) => (
            <tr key={r.rid} style={{ background: r.graded === 0 ? "#fef2f2" : r.missing ? "#fffbeb" : undefined }}>
              <td style={{ ...td, fontWeight: 600 }}>{r.name}</td><td style={td}>{r.location}</td><td style={td}>{r.total}</td><td style={td}>{r.graded}</td>
              <td style={{ ...td, color: r.missing ? "#b91c1c" : undefined, fontWeight: r.missing ? 600 : 400 }}>{r.missing}</td>
              <td style={td}>{fmt(r.avg)}</td><td style={td}>{fmt(r.max)}</td><td style={td}>{fmt(r.min)}</td><td style={td}>{r.fix || ""}</td><td style={td}>{r.review || ""}</td><td style={tdL}>{r.files}</td>
            </tr>))}</tbody>
        </table>
      </div>

      <List title="Phiếu máy đã tự sửa SBD / mã đề (kiểm tra lại cho chắc)" k="fix" rows={rep.fix} color="#7c3aed" />
      <List title="Phiếu cần xem lại (tô 2 ô, tô mờ, bỏ trống, tô Đúng toàn bộ...)" k="review" rows={rep.review} color="#b45309" />
      <List title="Thí sinh chưa có điểm (vắng thi / chưa chấm)" k="missing" rows={rep.missing} color="#b91c1c" noteCol={false} />
      <p style={{ fontSize: 12, color: "#6b7280", marginTop: 10 }}>Bấm đúp vào một dòng thí sinh để mở đề thi, ảnh bài làm và đáp án.</p>

      {open && (
        <ThiKhaoSatSheetModal schoolId={schoolId} examId={examId} subjectKey={sk} subjectLabel={subjByKey[sk]?.label || sk}
          classId={open.classId} student={open.student} canEdit={isAdmin} onClose={() => setOpen(null)} />
      )}
    </div>
  );
}
